<template lang="pug">
  .Content
    h2 {{title}}
    p {{text}}

</template>

<script>
  export default {
    name: 'block-popup',
    props: {
      title: {
        type: String,
        default: ''
      },
      text: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style scoped lang="scss">
  .Content {
    padding: 10px 20px;
    color: var(--basicText);

    h2 {
      font-size: 20px;
      margin-bottom: 15px;
    }

    p {
      font-size: 16px;
      margin: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/popups/BlockPopup.vue